import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const typesApi = createApi({
    reducerPath: 'typesApi',
    baseQuery: fetchBaseQuery({
        baseUrl: 'https://onza-api.ibm.kg/api/common/',
        prepareHeaders: (headers, { getState }) => {
            let { auth: { auth } } = getState();
            if (typeof auth == "string") {
                auth = JSON.parse(auth);
            }
            headers.set("Authorization", `Bearer ${auth?.accessToken}`);
            return headers;
        },
    }),
    tagTypes: ["Types"],
    endpoints: (builder) => ({
        getTypes: builder.query({
            query: () => `types`,
            providesTags: ["Types"],
        }),
        addTypes: builder.mutation({
            query: (newTypes) => ({
                url: 'types',
                method: 'POST',
                body: newTypes,
            }),
            invalidatesTags: ['Types'],
        }),
        deleteTypes: builder.mutation({
            query: ({ id }) => ({
                url: `types/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Types'],
        }),
    }),
})

export const { useGetTypesQuery, useAddTypesMutation, useDeleteTypesMutation } = typesApi